import { useSelector } from 'react-redux';
import { skipToken } from '@reduxjs/toolkit/query';

import { getCountry } from '@domains/user/store/slices/user-slice/user-slice';
import { getSelectedTask } from '../store/slices/document-review-slice';
import { useGetDocumentsByNidQuery } from '../store/api-slices/documents-by-nid.endpoints';

export const useDocumentsHistory = () => {
  const country = useSelector(getCountry);
  const selectedTask = useSelector(getSelectedTask);
  const nid = selectedTask?.nid;

  const queryArg = !country || !nid ? skipToken : { country, nid };

  const result = useGetDocumentsByNidQuery(queryArg);
  const data = result.data ?? [];

  return { ...result, data, nid };
};
